import React, { useState, useRef } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridReact } from "@ag-grid-community/react";
import "ag-grid-community/styles/ag-theme-quartz.css";
import Pagination from "../../CommonCompo/Pagination/pagination.js";
import { useCommon } from "../../../Hooks/Common/useCommon.js";
import { useOutpassEntry } from "../../../Hooks/Features/Gatepass/useOutpassentry.js";
import { SkeletonDataTable } from "../../Loader/Loader.jsx";
import GetPassRequest from "../GetpassRequest/GetPassRequest.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MultiSelect } from 'primereact/multiselect';
import DatePicker from "react-multi-date-picker";
import { Dialog } from "primereact/dialog";
import OutpassList from "../OutpassList/OutpassList.jsx";
import PanelHeaderTemplate from "../../CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate.jsx";
import CommonFilterDropdown from "../../CommonCompo/CommonFilterDropdown/CommonFilterDropdown.jsx";

export const OutpassEntry = () => {
  const { checkPermission, getValuePermission } = useCommon();
  const { tagRef, total, columnDefs, rowData, loader, showPagination, getGatePassDetails, showRequest, setShowRequest, showPendingRequest, setShowPendingRequest, filterValues, setFilterValues, filterOptions, isChange, setIsChange, editUser, setEditUser, pagination, setPagination, userShiftTime } = useOutpassEntry();
  const [showFiltersDrawer, setShowFiltersDrawer] = useState(false);
  const datePickerRef = useRef(null);

  return (
    <div ref={() => checkPermission(("OutpassEntry", tagRef))} className="gatepass-container">
      <div ref={tagRef} id='{"tabname": "gate_pass", "data": "gatepass_outpass_entry_tab"}'>
        <div className="d-flex justify-content-between align-items-center my-2 gap-3 px-3">
          <div className="d-flex gap-2 align-items-center flex-grow-1">
            <h5 className="mb-0 text-nowrap">Outpass Entry</h5>
          </div>
          <div className="d-flex justify-content-end align-items-center gap-2">
            <button className="sk-btn-primary rounded" onClick={() => getGatePassDetails()} title="Refresh"><FontAwesomeIcon icon="fa-solid fa-arrows-rotate" /></button>
            <button className="sk-btn-primary rounded" onClick={() => setShowFiltersDrawer(true)} title="Filters"><FontAwesomeIcon icon="fa-solid fa-filter" /></button>
            <button className="button btn-primary rounded" onClick={() => setShowRequest(true)}>+ Request</button>
          </div>
        </div>
        <div className="gate-pass-status-card mb-3">
          <div className="card-container px-2 py-3" style={{ borderTop: `5px solid #75bef8` }}>
            <div className="d-flex justify-content-between">
              <div className="w20 d-flex justify-content-center align-items-center gate-pass-card-icons" style={{ background: "#eaf6fe" }}>
                <FontAwesomeIcon icon="fas fa-file-pen" size="lg" style={{ color: "#75bef8" }} />
              </div>
              <div className="text-right">
                <h5 className="fw-bolder mb-0">{total?.total_applied || 0}</h5>
                <span className="fw-semibold">Applied</span>
              </div>
            </div>
          </div>
          <div className="card-container px-2 py-3" style={{ borderTop: `5px solid #1aaf27` }}>
            <div className="d-flex justify-content-between">
              <div className="w20 d-flex justify-content-center align-items-center gate-pass-card-icons" style={{ background: "#ccf3cf" }}>
                <FontAwesomeIcon icon="fas fa-thumbs-up" size="lg" style={{ color: "#1aaf27" }} />
              </div>
              <div className="text-right">
                <h5 className="fw-bolder mb-0">{total?.total_approved || 0}</h5>
                <span className="fw-semibold">Approved</span>
              </div>
            </div>
          </div>
          <div className="card-container px-2 py-3" style={{ borderTop: `5px solid #e73e3e` }}>
            <div className="d-flex justify-content-between">
              <div className="w20 d-flex justify-content-center align-items-center gate-pass-card-icons" style={{ background: "#ffe4e4" }}>
                <FontAwesomeIcon icon="fas fa-thumbs-down" size="lg" style={{ color: "#e73e3e" }} />
              </div>
              <div className="text-right">
                <h5 className="fw-bolder mb-0">{total?.total_rejected || 0}</h5>
                <span className="fw-semibold">Rejected</span>
              </div>
            </div>
          </div>
          <div className="card-container px-2 py-3" style={{ borderTop: `5px solid #95a5a3` }}>
            <div className="d-flex justify-content-between">
              <div className="w20 d-flex justify-content-center align-items-center gate-pass-card-icons" style={{ background: "#f3f3f3" }}>
                <FontAwesomeIcon icon="fas fa-folder-closed" className="me-0" size="lg" style={{ color: "#95a5a3" }} />
              </div>
              <div className="text-right">
                <h5 className="fw-bolder mb-0">{total?.total_closed || 0}</h5>
                <span className="fw-semibold">Closed</span>
              </div>
            </div>
          </div>
          <div className={`card-container px-2 py-3 ${!getValuePermission("gatepass_outpasslist_tab") && "gatepass-pending-card"}`} onClick={() => !getValuePermission("gatepass_outpasslist_tab") && setShowPendingRequest(true)} style={{ borderTop: `5px solid #fdd63c` }}>
            <div className="d-flex justify-content-between">
              <div className="w20 d-flex justify-content-center align-items-center gate-pass-card-icons" style={{ background: "#fff5d0" }}>
                <FontAwesomeIcon icon="fas fa-hourglass-start" size="lg" style={{ color: "#fdd63c" }} />
              </div>
              <div className="text-right">
                <h5 className="fw-bolder mb-0">{total?.total_pending || 0}</h5>
                <span className="fw-semibold">Pending to Approve</span>
              </div>
            </div>
          </div>
        </div>
        <div>
          {loader ? (
            <div style={{ height: "calc(100vh - 235px)" }}><SkeletonDataTable numSkeletons={17} /></div>
          ) : (
            <div className="ag-theme-alpine gatepass-ag-grid" style={{ height: "calc(100vh - 235px)" }}>
              <AgGridReact columnDefs={columnDefs} rowData={rowData} rowHeight={30} />
            </div>
          )}
        </div>
        <div >
          {showPagination && (
            <Pagination
              totalRecords={pagination?.totalRecords}
              totalPages={pagination?.totalPages}
              currentPage={pagination?.currentPage}
              displayPageOutOfTotal={pagination?.displayPageOutOfTotal}
              onPageChange={(e) => {setPagination((prev) => ({ ...prev, currentPage: e })); setFilterValues((prev) => ({...prev, apiCall: true}))}}
            />
          )}
        </div>

        <Dialog visible={showRequest} onHide={() => { setShowRequest(false); setEditUser({}); }} draggable={false} className="modal-small" header="Generate GatePass Request">
          <GetPassRequest filterOptions={filterOptions} editUser={editUser} onClose={() => { setShowRequest(false); setPagination((prev) => ({ ...prev, currentPage: 0 })); pagination?.currentPage === 0 && getGatePassDetails(); setEditUser({}); }} userShiftTime={userShiftTime} />
        </Dialog>

        <Dialog visible={showPendingRequest} onHide={() => { setShowPendingRequest(false); getGatePassDetails() }} draggable={false} className="modal-xsmall" style={{ height: "70vh" }} header="Pending Requests to Approve">
          <OutpassList filterValues={filterValues} />
        </Dialog>
      </div>

      {/* Right Panel Filters Drawer */}
      <div className={`sk-drawer-overlay ${showFiltersDrawer ? 'active' : ''}`} onClick={(e) => { if (e.target === e.currentTarget) setShowFiltersDrawer(false); }}>
        <div className={`sk-drawer-panel ${showFiltersDrawer ? 'open' : ''}`}>
          <div className="sk-drawer-header">
            <h5 className="sk-drawer-title">Filters</h5>
            <div className="d-flex align-items-center gap-2">
              <button className="sk-drawer-clear-btn" onClick={() => {
                setFilterValues({
                  ...filterValues,
                  users: [],
                  gatepass_leave_types: [],
                  request_to: [],
                  approved_by: [],
                  status: [],
                  date: null,
                  isChange: true
                });
              }}>Clear All</button>
              <button className="sk-drawer-close-btn" onClick={() => setShowFiltersDrawer(false)}>
                <FontAwesomeIcon icon="fa-solid fa-xmark" />
              </button>
            </div>
          </div>
          <div className="sk-drawer-body">
            <div className='d-flex flex-column gap-4'>
              {/* Datepicker Range Filter */}
              <div className="sk-drawer-filter-group">
                <div className="task-list-filter-label">Select Date Range</div>
                <DatePicker
                  ref={datePickerRef}
                  placeholder="Date"
                  range
                  rangeHover
                  value={filterValues?.date}
                  onChange={(e) => {
                                            if (!e || e.length === 2) {
                                                setFilterValues((prev) => ({ ...prev, date: e }));
                    setIsChange(true);
                    if (e && e.length === 2) {
                      datePickerRef.current?.closeCalendar();
                    }
                                            }
                                        }}
                  onClose={() => { if (isChange) { getGatePassDetails(); setIsChange(false); } }}
                  style={{ width: "100%" }}
                  containerStyle={{ width: "100%" }}
                />
              </div>

              {/* Status Filter */}
              <div className="sk-drawer-filter-group">
                <div className="task-list-filter-label">Status</div>
                <MultiSelect
                  title="Status"
                  placeholder="Status"
                  options={filterOptions?.status}
                  optionLabel="status_name"
                  value={filterValues?.status}
                  onChange={(e) => { setFilterValues((prev) => ({ ...prev, status: e.target.value })); setIsChange(true); }}
                  onHide={() => { if (isChange) { getGatePassDetails(); setIsChange(false); } }}
                  panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'status', filterValues?.status, () => setFilterValues((prev) => ({ ...prev, status: [] })), () => getGatePassDetails("status"))}
                  filter
                  filterInputAutoFocus
                  className="sk-input-dd w-100"
                />
              </div>

              {/* Request To & Approved By */}
              <div className="sk-drawer-filter-group">
                <div className="task-list-filter-label">Approvers</div>
                <div className="d-flex flex-column gap-2">
                  <MultiSelect
                    title="Request To"
                    placeholder="Request To"
                    options={filterOptions?.approved_by}
                    optionLabel="user_display_name"
                    value={filterValues?.request_to}
                    onChange={(e) => { setFilterValues((prev) => ({ ...prev, request_to: e.target.value })); setIsChange(true); }}
                    onHide={() => { if (isChange) { getGatePassDetails(); setIsChange(false); } }}
                    panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'request_to', filterValues?.request_to, () => setFilterValues((prev) => ({ ...prev, request_to: [] })), () => getGatePassDetails("request_to"))}
                    filter
                    filterInputAutoFocus
                    className="sk-input-dd w-100"
                  />
                  <MultiSelect
                    title="Approved By"
                    placeholder="Approved By"
                    options={filterOptions?.approved_by}
                    optionLabel="user_display_name"
                    value={filterValues?.approved_by}
                    onChange={(e) => { setFilterValues((prev) => ({ ...prev, approved_by: e.target.value })); setIsChange(true); }}
                    onHide={() => { if (isChange) { getGatePassDetails(); setIsChange(false); } }}
                    panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'approved_by', filterValues?.approved_by, () => setFilterValues((prev) => ({ ...prev, approved_by: [] })), () => getGatePassDetails("approved_by"))}
                    filter
                    filterInputAutoFocus
                    className="sk-input-dd w-100"
                  />
                </div>
              </div>

              {/* Core Filters */}
              <div className="sk-drawer-filter-group">
                <div className="task-list-filter-label">User & Leave Info</div>
                <CommonFilterDropdown
                  fields={[
                    { key: "users", label: "User", col: 12 },
                    { key: "gatepass_leave_types", label: "Leave Type", col: 12 }
                  ]}
                  filterValues={filterValues}
                  setFilterValues={setFilterValues}
                />
              </div>
            </div>
          </div>
          <div className="sk-drawer-footer">
            <button className="sk-btn .sk-btn-primary-filter w-100 py-2" onClick={() => {
              getGatePassDetails();
              setShowFiltersDrawer(false);
            }}>Apply Filters</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OutpassEntry;
